<template>
  <div class="booking-form__payment">
    <div class="header mt-4 mb-5">
      <h3 class="font-bold">Payment Summary</h3>
    </div>
    <div>
      <label class="label">Promo Code</label>
    </div>
    <div class="promo mb-5 flex flex-wrap justify-between">
      <div>
        <input type="text" class="input" />
      </div>
      <div class="font-semibold flex justify-between gap-4">
        <div class="mr-2 mt-1">
          <img src="@/assets/images/icons/credit-card.png" />
        </div>
        <div>
          <p>PAYMENT DUE</p>
          <p class="payment-due">₦{{ costTypeObject.totalCost }}</p>
        </div>
      </div>
    </div>
    <div class="container-fluid payment-summary">
      <div class="row">
        <div class="col-12">
          <p class="font-semibold">Payment Summary</p>
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/service.svg"
                  alt=""
              /></span>
              SERVICE
            </p>
            <p class="shipping-detail">
              {{ paymentDetails.shippingservice ? paymentDetails.shippingservice.orgName : "N/A" }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/net-shipping-cost.svg"
                  alt="" /></span
              >NET SHIPPING COST
            </p>
            <p class="shipping-detail">₦{{ costTypeObject.netPrice }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/booking-channel.svg"
                  alt="" /></span
              >HANDLING CHARGES
            </p>
            <p class="shipping-detail">₦{{ costTypeObject.handlingCharges }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/insurance.svg"
                  alt="" /></span
              >INSURANCE
            </p>
            <p class="shipping-detail">₦{{ costTypeObject.insuranceFee }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/booking-channel.svg"
                  alt="" /></span
              >RETURN SHIPPING COST
            </p>
            <p class="shipping-detail">₦0.00</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/stop-diversion-cost.svg"
                  alt="" /></span
              >STOP/DIVERSION COST
            </p>
            <p class="shipping-detail">₦0.00</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/total.svg"
                  alt="" /></span
              >TOTAL
            </p>
            <p class="shipping-detail">₦{{ costTypeObject.totalCost }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/promo-code.svg"
                  alt="" /></span
              >PROMO CODE
            </p>
            <p class="shipping-detail">******</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/total.svg"
                  alt="" /></span
              >DISCOUNT TOTAL
            </p>
            <p class="shipping-detail">₦0.00</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/tax-vat-charges.svg"
                  alt="" /></span
              >Tax/VAT
            </p>
            <p class="shipping-detail">₦{{ costTypeObject.vat }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/payment-due.svg"
                  alt="" /></span
              >PAYMENT DUE
            </p>
            <p class="shipping-detail">₦0.00</p>
          </div>
        </div>
      </div>
    </div>

    <div class="my-5">
      <input type="checkbox" v-model="terms" id="terms" />
      <label for="terms" class="label text-sm"
        >I accept the terms & conditions of this service (SLA, Insurance,
        Demurage Fee, Return Policy)</label
      >
    </div>

    <div class="button-wrapper">
      <p class=" cursor-pointer underline" @click="$emit('back-one-form')">
        Back
      </p>
      <div>
        <div class="flex gap-2 items-center">
          <el-dropdown class="h-full">
            <button
              :disabled="!terms"
              :class="{ 'opacity-25': !terms }"
              class="payment-assign h-full font-semibold w-32 rounded flex justify-between items-center p-2 px-3"
            >
              <span class="mr-3 pr-2">Pay</span>

              <ArrowDownBlackIcon :style="{ width: '17px', heigth : '10px'}" />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button @click="showPaymentModal">Charge Card</button>
              </el-dropdown-item>


              <el-dropdown-item>
                <button>Save Quote</button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <payment-modal
      :show-modal="isPaymentModal"
      :email="shipper.email"
      :paystackkey="paystackkey"
      :total="Number(9000)"
      @process-paystack="createTransaction"
      @close-modal="isPaymentModal = false"
    />
  </div>
</template>

<script>
import PaymentModal from "./Modals/NewBookingPaymentModal";
import ArrowDownBlackIcon from "../../../../UI/svgs/ArrowDownBlackIcon.vue";

export default {
  name: "payment-form",
  components: {
    PaymentModal,
    ArrowDownBlackIcon
  },
  data() {
    return {
      transactionId: '',
      isPaymentModal: false,
      paymentDetails: {},
      terms: false,
      paystackkey: "pk_test_d81d41eedf44bac3067b59281f5aec31efc13049",
    };
  },
  computed: {
    shipper() {
      return this.$store.getters.shipperInformation;
    },
    consignee() {
      return this.$store.getters.consigneeInformation;
    },
    packageInformation() {
      return this.$store.getters.packageInformation;
    },
    shippingInformation() {
      return this.$store.getters.shippingInformation;
    },
    paymentInformation() {
      return this.$store.getters.paymentInformations;
    },
    shippingService() {
      return this.$store.getters.shippingService.shippingService;
    },
    costTypeObject() {
      return this.$store.state.bookingModule.costTypes;
    },
  },
  mounted() {
    this.getPaymentDetails();
    this.transactionId = this.shippingInformation.transactionId
  },
  methods: {
    async createTransaction(status) {
      this.isPaymentModal = false;

      try {
      this.changeStatus(status);
        
      } catch (error) {
        this.handleError(error);
      }
    },
    async changeStatus(status) {
      let payload = {
        status: status,
        paymentStatus: status,
        breakdown: this.costTypeObject,
        productId: this.$store.state.bookingModule.shippingId,
        payment_type: "card",
        payment_date: this.shippingInformation.updatedAt,
      };
      try {
        const response = await this.$_updatePaymentStatus(
          payload,
          this.transactionId
        );

        console.log(JSON.stringify(response, null, 2));

        if (response.data.success == true) {
          this.$store.dispatch("removeOldConsigneeData");
          this.$router.push({
            name: "Booking3plDirection",
          });
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async getPaymentDetails() {
      try {
        const response = await this.$_getPaymentDetails(
          this.$store.getters.shippingId
        );
        this.paymentDetails = response.data.data.shipping;
      } catch (error) {
        this.handleError(error);
      }
    },
    showPaymentModal() {
      this.isPaymentModal = true;
      if (!this.terms) {
        this.generateToast(
          "please accept terms and conditions before proceeding",
          "error"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__payment {
  padding: 2rem 4rem;
}
.promo {
  display: flex;
  justify-content: space-between;
  input {
    width: 18rem;
  }
}
.bill-info {
  background: #f2f7fd;
  border: 1px dashed #94abc7;
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
  padding: 0 0.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
}
.row {
  padding-bottom: 1.5rem;
}
.center {
  padding-left: 4rem;
  padding-right: 0;
}
.right {
  padding-left: 5rem;
}
.shipping-detail-title {
  color: #979797;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  span {
    padding-right: 0.5rem;
  }
}
.shipping-detail {
  color: #10233e;
  font-size: 0.9rem;
  font-weight: 500;
  padding-left: 1.5rem;
}
.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}
.radio-label span::after {
  background: #bec4d5;
}
.gene-button {
  background: #dae8f6;
}
.payment-assign {
  background: #fcc210;
  color: #10233e;
}
.payment-due {
  color: #09b78a;
}
</style>
